module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch1_20210921115649_T.67292182.jpg";